import { jsx as _jsx } from "react/jsx-runtime";
import BreadcrumbComponent from '@helsenorge/core-cms/breadcrumb';
import { envSafeUrl } from '@helsenorge/framework-utils/components/safe-html/safe-html';
import { getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';
import useResources from '@helsenorge/framework-utils/resources/useResources';
import { currentConfiguration, resolve } from '../common/configuration';
import { getResources, Projects } from '../resources';
import styles from './styles.module.scss';
const getBreadcrumbLink = (contentResources, pageConfiguration) => {
    if (contentResources && pageConfiguration?.NavigateBackLinkTitle && pageConfiguration.NavigateBackLinkURL) {
        const name = resolve(pageConfiguration.NavigateBackLinkTitle, contentResources);
        const url = resolve(pageConfiguration.NavigateBackLinkURL, contentResources);
        if (name && url) {
            return {
                name: name,
                url: envSafeUrl(url),
            };
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
};
const Breadcrumb = props => {
    const resources = useResources(Projects.FRAMEWORK, getResources);
    const contentResources = useResources(Projects.CONTENT, getResources);
    const pageConfiguration = currentConfiguration();
    const pageBreadcrumbLinks = getBreadcrumbLink(contentResources, pageConfiguration);
    const homeLabel = resources?.breadCrumb_Forsiden;
    const getCmsBreadcrumbLink = (link) => {
        let name = undefined;
        if (link && link.resourceId && contentResources) {
            name = contentResources[link.resourceId];
        }
        else if (link && link.name) {
            name = link.name;
        }
        return !name
            ? undefined
            : {
                name: name,
                url: link ? link.url : '',
                renderAsRouterLink: link?.renderAsRouterLink,
            };
    };
    return (_jsx("div", { className: styles.breadcrumb, children: _jsx(BreadcrumbComponent, { homeLabel: homeLabel, homeUrl: getTjenesterUrl(), link: getCmsBreadcrumbLink(props.link || pageBreadcrumbLinks) }) }));
};
export default Breadcrumb;
